import React, { Component } from 'react';
import DashboardAdmin from "../views/admin/Dashboard";

class Dashboard extends Component {
  render() {
    return <DashboardAdmin {...this.props} />
  }
}

export default Dashboard;